import { TypographyCaption, TypographyH4 } from '@heidi/design-system/typography';
import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { communityTemplateDetailsMessages } from '../../communityTemplateDetails.messages';

interface HowToUseSectionProps {
  howToUseRichValues: {
    createAction: (chunks: ReactNode) => ReactNode;
    useTemplate: (chunks: ReactNode) => ReactNode;
  };
  isFormTemplate: boolean;
}

export const HowToUseSection = ({
  howToUseRichValues,
  isFormTemplate,
}: HowToUseSectionProps) => {
  return (
    <div className="flex flex-col gap-3">
      <TypographyH4>
        <FormattedMessage {...communityTemplateDetailsMessages.howToUseHeading} />
      </TypographyH4>
      <div className="flex flex-col gap-4 text-text-primary">
        <TypographyCaption>
          <FormattedMessage
            {...(isFormTemplate
              ? communityTemplateDetailsMessages.howToUseFormParagraph1
              : communityTemplateDetailsMessages.howToUseNoteParagraph1)}
            values={howToUseRichValues}
          />
        </TypographyCaption>
        <TypographyCaption>
          <FormattedMessage
            {...(isFormTemplate
              ? communityTemplateDetailsMessages.howToUseFormParagraph2
              : communityTemplateDetailsMessages.howToUseNoteParagraph2)}
            values={howToUseRichValues}
          />
        </TypographyCaption>
        <TypographyCaption>
          <FormattedMessage
            {...(isFormTemplate
              ? communityTemplateDetailsMessages.howToUseFormParagraph3
              : communityTemplateDetailsMessages.howToUseNoteParagraph3)}
          />
        </TypographyCaption>
      </div>
    </div>
  );
};
